if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}

(() => {
  const desktopFilters = window.matchMedia('(min-width: 1280px)');
  let frame = null;

  const updateFacetSidebarHeight = () => {
    frame = null;

    const sidebar = document.querySelector('#FacetFiltersContainer > .sticky-element');
    if (!sidebar) return;

    if (!desktopFilters.matches) {
      sidebar.style.removeProperty('max-height');
      return;
    }

    const top = Math.max(0, sidebar.getBoundingClientRect().top);
    const availableHeight = Math.max(80, window.innerHeight - top - 20);
    sidebar.style.maxHeight = `${availableHeight}px`;
  };

  const scheduleFacetSidebarHeightUpdate = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateFacetSidebarHeight);
  };

  window.addEventListener('scroll', scheduleFacetSidebarHeightUpdate, { passive: true });
  window.addEventListener('resize', scheduleFacetSidebarHeightUpdate);
  document.addEventListener('collection:rerendered', scheduleFacetSidebarHeightUpdate);

  scheduleFacetSidebarHeightUpdate();
})();
